import React from 'react';

import { SortContext } from 'src/providers';

export function useSort() {
  return React.useContext(SortContext);
}
